import * as React from "react";
import { useDynamicModule } from "@grandvisionhq/utils";
const AdyenContext = React.createContext({
  clientKey: "",
  environment: "test",
  AdyenModule: {
    result: void 0,
    loading: true
  }
});
const useAdyen = () => React.useContext(AdyenContext);
const AdyenProvider = ({ children, settings }) => {
  const [result, loading] = useDynamicModule(
    async () => {
      if (typeof window !== "undefined") {
        return await import("@adyen/adyen-web").then((module) => module.default);
      }
      return void 0;
    },
    "@adyen/adyen-web",
    []
  );
  const [pspInfo, setPspInfo] = React.useState(settings?.pspInfo);
  const updatePspInfo = React.useCallback((updates) => {
    setPspInfo((prev) => {
      const isMerchantConfigUnchanged = prev?.merchantId === updates.merchantId && prev?.merchantName === updates.merchantName && prev?.gatewayMerchantId === updates.gatewayMerchantId;
      if (isMerchantConfigUnchanged) return prev;
      return { ...prev, ...updates };
    });
  }, []);
  const memoizedSettings = React.useMemo(
    () => ({
      ...settings,
      pspInfo,
      updatePspInfo,
      AdyenModule: { result: result ?? void 0, loading }
    }),
    [settings, pspInfo, result, loading, updatePspInfo]
  );
  return /* @__PURE__ */ React.createElement(AdyenContext.Provider, { value: memoizedSettings }, children);
};
export {
  AdyenProvider,
  useAdyen
};
//# sourceMappingURL=context.js.map
